import HeroSection from '../components/home/HeroSection';
import ServicesSection from '../components/home/ServicesSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import BlogCarousel from '../components/home/BlogCarousel';
import GallerySection from '../components/home/GallerySection';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export default function HomePage() {
  const { t } = useTranslation();
  return (
    <main>
      <Helmet>
        <title>{t('seo.home_title')}</title>
        <meta name="description" content={t('seo.home_desc')} />
      </Helmet>
      <HeroSection />
      <ServicesSection />
      <HowItWorksSection />
  <GallerySection />
      <BlogCarousel />
    </main>
  );
}
